import React, { ReactNode, useRef } from 'react';
import { styled } from 'styled-components';

type Props = {
  children: ReactNode;
  displayChar?: String | number | null;
};

const NotificationBadge: React.FC<Props> = (props) => {
  const refobj = useRef<HTMLDivElement>(null);
  const isCountStop =
    typeof props.displayChar == 'number' && props.displayChar > 99;
  const style = {
    '--content-width': refobj.current ? refobj.current.clientWidth + 'px' : 0,
    '--content-char': props.displayChar
      ? '"' + (isCountStop ? '99+' : props.displayChar) + '"'
      : '',
  } as React.CSSProperties;

  return (
    <Container ref={refobj} style={style}>
      {props.children}
      <div className="notfi-badge"></div>
    </Container>
  );
};

export default NotificationBadge;

const Container = styled.div`
  position: relative;

  .notfi-badge::after {
    /* prettier-ignore */
    content: var(--content-char);
    color: white;
    position: absolute;
    top: -2px;
    left: calc(var(--content-width) - 10px);
    background-color: var(--red-700-button-accent);
    font-size: 0.8em;
    font-weight: 700;
    padding: 3px 4px 1px;
    line-height: 1em;
    border-radius: 8px;
  }
`;
